export const PURCHASE_ORDER_STATUS_LABELS = {
  draft: "Bozza",
  email_prepared: "Email pronta",
  sent: "Inviato",
  partially_received: "Arrivato in parte",
  received: "Ricevuto",
  cancelled: "Annullato",
} as const;
